import { useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { Address } from "viem";

import { convertHexToBech32 } from "shared/web3/utils";

import { StakingDelegatorValidatorsQueryResponse } from "./gen";

type Params = {
  address?: Address;
};

export const useDelegatorValidatorsQuery = (params: Params) => {
  return useQuery({
    queryKey: ["cosmos", "staking", "delegators", "validators", params],
    queryFn: async () => {
      invariant(params.address);
      const bech32AccountAddress = convertHexToBech32(params.address);
      const response = await fetch(
        `cosmos-api/cosmos/staking/v1beta1/delegators/${bech32AccountAddress}/validators`
      );

      const data: StakingDelegatorValidatorsQueryResponse =
        await response.json();

      console.log(data);
      return data;
    },
  });
};
